/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

export const en = {
  'sharedComponents': {
    'dateRange': {
      'start': 'Start Date...',
      'end': 'End Date...'
    },
    'timeInterval': {
      'startTime': 'HH:mm ex: 08:00',
      'endTime': 'HH:mm ex: 16:00'
    },
    'numberInterval': {
      'startNumber': 'Start...',
      'endNumber': 'End...'
    }
  }
};
